export const beverages = [
    {
      "id": 1,
      "name": "Coca-Cola",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Coca-Cola-Classic-Small-1:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Coca-Cola-Classic-Small-1:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "Coca-Cola® is a refreshing McDonald's soda option that complements all of your menu favorites.",
      "ingredients": [
        {
          "id": 1,
          "name": "Coca-Cola",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/coca_cola"
        }
      ],
      "price": 4
    },
    {
      "id": 2,
      "name": "Sprite",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Sprite-Small:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Sprite-Small:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "Cool off with the refreshing McDonald's Sprite® - the classic and delicious lemon-lime fountain drink. Now, you might be asking does Sprite® have caffeine? No, Sprite® is a caffeine-free soda that makes the perfect addition to any McDonald’s Combo Meal. There are 140 calories in a Small Sprite® at McDonald's.",
      "ingredients": [
        {
          "id": 1,
          "name": "Coca-Cola",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/coca_cola"
        }
      ],
      "price": 4
    },
    {
      "id": 3,
      "name": "Dr Pepper",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Dr-Pepper-Small-1:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Dr-Pepper-Small-1:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "Satisfy your taste buds with the unique taste of Dr Pepper® at McDonald's. Wondering what flavor is Dr Pepper®? This classic and refreshing fountain drink is a unique blend of 23 flavors. Dr Pepper® pairs perfectly with your favorite McDonald’s Burgers and World Famous Fries®. There are 140 calories in a small Dr Pepper at McDonald's. Available in extra small, small, medium, and large.",
      "ingredients": [
        {
          "id": 1,
          "name": "Coca-Cola",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/coca_cola"
        }
      ],
      "price": 6
    },
    {
      "id": 4,
      "name": "Fanta Orange",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-fanta-orange-1:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-fanta-orange-1:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "McDonald’s Fanta® Orange is a caffeine-free soft drink full of bubbly, refreshing orange flavor. There are 150 calories in a small Fanta® Orange. Fanta® Orange soda is part of McDonald’s $1 Any Size Soft Drinks on the $1 on our $1 $2 $3 Dollar Menu. Available in small, medium, and large fountain drink sizes.",
      "ingredients": [
        {
          "id": 1,
          "name": "Coca-Cola",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/coca_cola"
        }
      ],
      "price": 4
    },
    {
      "id": 5,
      "name": "Diet Coke",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Diet-Coke-Small-1:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Diet-Coke-Small-1:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "Try an icy cold Diet Coke®, with zero calories. It’s a staple to any McDonald's meal available on the $1 $2 $3 Dollar Menu. Wondering why Diet Coke® at McDonald’s tastes so good? We ensure our Coke® products are fresh and always tasting the way they should by following the guidelines set by Coca-Cola®, using a ratio of syrup that allows ice to melt, and pre chilling the Coca-Cola® syrup and water before they enter our soda fountain! Diet Coke® is available in extra small, small, medium and large fountain drink sizes.",
      "ingredients": [
        {
          "id": 1,
          "name": "Diet Coke",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/diet_coke"
        },
        {
          "id": 2,
          "name": "Ice",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-ice"
        }
      ],
      "price": 7
    },
    {
      "id": 6,
      "name": "Hi-C® Orange Lavaburst®",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-hi-c-lavaburst:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-hi-c-lavaburst:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "You asked for it, you got it—Hi-C Orange at McDonald’s is back! With a fruity flavor that teases your tastebuds it’s the perfect addition to any McDonald’s meal. You can use the Hi-C Orange Finder which will be updated weekly as Hi-C Orange is rolled out across the country to find the closest McDonald’s near you already offering the beverage. There are 160 calories in a small Hi-C Orange.",
      "ingredients": [
        {
          "id": 1,
          "name": "Diet Coke",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/diet_coke"
        },
        {
          "id": 2,
          "name": "Ice",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-ice"
        }
      ],
      "price": 10
    },
    {
      "id": 7,
      "name": "Strawberry Banana Smoothie",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Strawberry-Banana-Smoothie-Medium:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Strawberry-Banana-Smoothie-Medium:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "The McCafé® Strawberry Banana Smoothie recipe features the perfect combination of real strawberry and banana fruit purees and juices, blended with creamy low fat yogurt and ice. As a part of the McCafé® Menu, Strawberry Banana Smoothie is available in small, medium, and large sizes. There are 190 calories in a small McDonald's Strawberry Banana Smoothie. ",
      "ingredients": [
        {
          "id": 1,
          "name": "Strawberry Banana Fruit",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/strawberry_fruit_base"
        },
        {
          "id": 2,
          "name": "Ice",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-ice"
        },
        {
          "id": 3,
          "name": "Lowfat Smoothie Yogurt",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/lowfat_smoothie_yogurt"
        }
      ],
      "price": 12
    },
    {
      "id": 7,
      "name": "Mango Pineapple Smoothie",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Mango-Pineapple-Smoothie-Small:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Mango-Pineapple-Smoothie-Small:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "The McDonald’s Mango Pineapple Smoothie recipe features the sweet combination of fruit juices and purees such as mango and pineapple, blended with creamy low fat yogurt and ice. Find all our smoothies on the McCafé® Menu in small, medium and large. There are 200 calories in a small mango pineapple smoothie at McDonald's.",
      "ingredients": [
        {
          "id": 1,
          "name": "Mango Pineapple Fruit Base",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/mango_fruit_base"
        },
        {
          "id": 2,
          "name": "Ice",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-ice"
        },
        {
          "id": 3,
          "name": "Lowfat Smoothie Yogurt",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/lowfat_smoothie_yogurt"
        }
      ],
      "price": 12
    },
    {
      "id": 8,
      "name": "Sweet Tea",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Iced-Tea-Large-drink:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Iced-Tea-Large-drink:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "McDonald’s Sweet Tea is made from a briskly refreshing blend of orange pekoe and pekoe cut black tea, sweetened to perfection. Sweet Tea from McDonald’s is part of the Beverages Menu. Available in extra small, small, medium and large.",
      "ingredients": [
        {
          "id": 1,
          "name": "Brewed Tea",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/default_logo"
        },
        {
          "id": 2,
          "name": "Ice",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-ice"
        },
        {
          "id": 3,
          "name": "Medium Invert Sugar",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/default_logo"
        }
      ],
      "price": 5
    },
    {
      "id": 9,
      "name": "Unsweetened Iced Tea",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Iced-Tea-Large-unsweetened:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Iced-Tea-Large-unsweetened:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "McDonald’s Iced Tea is made with a brisk blend of orange pekoe black tea, freshly brewed and served ice cold. McDonald’s Unsweet Iced Tea is available in extra small, small, medium and large on the McDonald’s drinks menu.",
      "ingredients": [
        {
          "id": 1,
          "name": "Brewed Tea",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/default_logo"
        },
        {
          "id": 2,
          "name": "Ice",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-ice"
        },
        {
          "id": 3,
          "name": "Medium Invert Sugar",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/default_logo"
        }
      ]
    },
    {
      "id": 10,
      "name": "Hot Tea",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-hot-tea:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-hot-tea:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "Refresh your mornings with the best Hot Tea at McDonald's. McDonald's Hot Tea has a robust black tea flavor with hints of floral and orange notes. There are 10 calories in a small McDonald's Hot Tea. Enjoy a McDonald's Hot Tea when you order with Mobile Order & Pay! Pair a Hot Tea with any of your favorite McCafé® Bakery or Breakfast items to give a perfect start to your morning.",
      "ingredients": [
        {
          "id": 1,
          "name": "Brewed Tea",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/default_logo"
        },
        {
          "id": 2,
          "name": "Ice",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-ice"
        },
        {
          "id": 3,
          "name": "Medium Invert Sugar",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/default_logo"
        }
      ],
      "price": 5
    },
    {
      "id": 11,
      "name": "Minute Maid Premium Orange Juice",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Minute-Maid-Orange-Juice-Medium-1:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Minute-Maid-Orange-Juice-Medium-1:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "100% orange juice, packed with Vitamin C. Available in Small, Medium and Large.",
      "ingredients": [
        {
          "id": 1,
          "name": "Ice",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-ice"
        },
        {
          "id": 2,
          "name": "Medium Invert Sugar",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/default_logo"
        }
      ],
      "price": 6
    },
    {
      "id": 12,
      "name": "Honest Kids® Appley Ever After® Organic Juice Drink",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-appley-ever-after:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-appley-ever-after:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "onest Kids Juice drink is sweetened only with fruit juice, and it’s an organic drink perfect for a kids meal! If you’re looking for kids organic juice drink options, add the Honest Kids® Appley Ever After® Organic Juice Drink to any Happy Meal®!",
      "ingredients": [
        {
          "id": 1,
          "name": "Appley Ever After",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/default_logo"
        }
      ],
      "price": 8
    },
    {
      "id": 13,
      "name": "1% Low Fat Milk Jug",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-1-Low-Fat-Milk-Jug:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-1-Low-Fat-Milk-Jug:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "McDonald's Milk Jug is a low fat milk and an excellent source of calcium and a good source of vitamin A&D! Add it to a Happy Meal®",
      "ingredients": [
        {
          "id": 1,
          "name": "1% Low Fat Milk Jug",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/1_low_fat_milk"
        }
      ],
      "price": 9
    },
    {
      "id": 14,
      "name": "Reduced Sugar* Low Fat Chocolate Milk Jug",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Fat-Free-Chocolate-Milk-Jug:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-Fat-Free-Chocolate-Milk-Jug:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "A handheld chocolate milk jug, full of low fat chocolate milk, a good source of Vitamin A&D.",
      "ingredients": [
        {
          "id": 1,
          "name": "Reduced Sugar Low Fat Chocolate Milk",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/default_logo"
        }
      ],
      "price": 12
    },
    {
      "id": 15,
      "name": "Hot Chocolate",
      "img": [
        {
          "sm": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-McCafe-Hot-Chocolate-Medium:1-4-product-tile-desktop"
        },
        {
          "lg": "https://s7d1.scene7.com/is/image/mcdonalds/t-mcdonalds-McCafe-Hot-Chocolate-Medium:product-header-mobile?wid=768&hei=441&dpr=off"
        }
      ],
      "desc": "Taste the delicious chocolatey flavor of a McCafé® Hot Chocolate. Hot chocolate made with steamed whole milk, rich chocolate syrup and topped with whipped topping and chocolate drizzle. There are 370 calories in a small Hot Chocolate. ",
      "ingredients": [
        {
          "id": 1,
          "name": "Whole Milk",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/Whole-Milk"
        },
        {
          "id": 2,
          "name": "Chocolate Syrup",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/chocolate_syrup"
        },
        {
          "id": 3,
          "name": "Whipped Light Cream",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/whipped_cream"
        },
        {
          "id": 4,
          "name": "Chocolate Drizzle",
          "img": "https://s7d1.scene7.com/is/image/mcdonalds/chocolate_drizzle"
        }
      ],
      "price": 15
    }
  ]